import React from "react";
import {
  Text,
  Box,
  UnorderedList,
  ListItem,
  useColorMode,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import PageLayout from "./PageLayout";

const PrivacyPolicy: React.FC = () => {
  const { colorMode } = useColorMode();
  const { t } = useTranslation();

  const textColor = colorMode === "light" ? "gray.700" : "gray.200";

  return (
    <PageLayout title={t("privacyPolicy.title", "Privacy Policy")}>
      <Box>
        <Text mb={4} color={textColor}>
          {t("privacyPolicy.lastUpdated", "Last Updated: January 1, 2023")}
        </Text>

        <Text mb={4} color={textColor}>
          {t(
            "privacyPolicy.introduction",
            "At QazBilim, we value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our services."
          )}
        </Text>

        <Text fontWeight="bold" mt={6} mb={2} color={textColor}>
          {t("privacyPolicy.infoWeCollect", "Information We Collect")}
        </Text>

        <UnorderedList mb={4} color={textColor}>
          <ListItem>
            {t(
              "privacyPolicy.accountInfo",
              "Account information such as name and email address"
            )}
          </ListItem>
          <ListItem>
            {t("privacyPolicy.usageData", "Usage data and reading preferences")}
          </ListItem>
          <ListItem>
            {t("privacyPolicy.deviceInfo", "Device information and IP address")}
          </ListItem>
        </UnorderedList>

        <Text fontWeight="bold" mt={6} mb={2} color={textColor}>
          {t("privacyPolicy.howWeUseInfo", "How We Use Your Information")}
        </Text>

        <UnorderedList mb={4} color={textColor}>
          <ListItem>
            {t(
              "privacyPolicy.provideService",
              "To provide and maintain our service"
            )}
          </ListItem>
          <ListItem>
            {t(
              "privacyPolicy.improveService",
              "To improve and personalize your experience"
            )}
          </ListItem>
          <ListItem>
            {t(
              "privacyPolicy.communicate",
              "To communicate with you about service updates"
            )}
          </ListItem>
        </UnorderedList>

        <Text fontWeight="bold" mt={6} mb={2} color={textColor}>
          {t("privacyPolicy.dataSecurity", "Data Security")}
        </Text>

        <Text mb={4} color={textColor}>
          {t(
            "privacyPolicy.securityMeasures",
            "We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security."
          )}
        </Text>

        <Text fontWeight="bold" mt={6} mb={2} color={textColor}>
          {t("privacyPolicy.contact", "Contact Us")}
        </Text>

        <Text color={textColor}>
          {t(
            "privacyPolicy.contactInfo",
            "If you have any questions about this Privacy Policy, please contact us at privacy@qazbilim.org"
          )}
        </Text>
      </Box>
    </PageLayout>
  );
};

export default PrivacyPolicy;
